import React from "react";
import { useDispatch } from "react-redux";
import { DropdownItem } from "Components/ReactstrapSlim";
import { HeaderDropDownMenuResources } from "./HeaderDropDownMenuResources";

const supportUrl = "https://support.liquidspace.com";

interface HeaderAnonymousDropDownMenuProps {
   redirectToMyLiquidSpaceAfterSignIn?: boolean;
}

export const HeaderAnonymousDropDownMenu: React.FC<HeaderAnonymousDropDownMenuProps> = ({ redirectToMyLiquidSpaceAfterSignIn }) => {
   const dispatch = useDispatch();
   const openLoginPopup = (signingMode: LSStore.SigningMode) => {
      dispatch(LSStore.signingModalSlice.actions.open({
         initialMode: signingMode,        
         popUpRedirectUrl: redirectToMyLiquidSpaceAfterSignIn ? "/my/index" : undefined
      }));
   }

   return <>
      <HeaderDropDownMenuResources isAuthenticated={false} />
      <DropdownItem divider className="d-md-none" />
      <DropdownItem onClick={() => openLoginPopup(LSStore.SigningMode.Login)}>
         Log in
      </DropdownItem>
      <DropdownItem onClick={() => openLoginPopup(LSStore.SigningMode.Register)}>
         Sign up
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem tag="a" href="/share-office-meeting-space">
         Become a Host
      </DropdownItem>
      <DropdownItem tag="a" href={supportUrl}>
         Help
      </DropdownItem>
   </>;
}